export default "__VITE_ASSET__CpTM58ad__";